import {Plural, Trans} from '@lingui/react/macro'

import {
  type CommonNavigatorParams,
  type NativeStackScreenProps,
} from '#/lib/routes/types'
import {nameSegmentToIdentifier} from '#/lib/strings/profile-path'
import {makeRecordUri} from '#/lib/strings/url-helpers'
import {usePostQuery} from '#/state/queries/post'
import {PostQuotes as PostQuotesComponent} from '#/view/com/post-thread/PostQuotes'
import * as Layout from '#/components/Layout'

type Props =
  | NativeStackScreenProps<CommonNavigatorParams, 'PostQuotes'>
  | NativeStackScreenProps<CommonNavigatorParams, 'PostByNameQuotes'>
export const PostQuotesScreen = ({route}: Props) => {
  const {rkey} = route.params
  const name =
    route.name === 'PostByNameQuotes'
      ? // AtUri throws synchronously on an empty/malformed host, so an
        // unresolvable segment falls back to the same sentinel
        // isInvalidHandle() already recognizes, rather than '' - the
        // resulting failed resolution is handled the same way any other
        // nonexistent handle already is.
        (nameSegmentToIdentifier(route.params.name) ?? 'handle.invalid')
      : route.params.name
  const uri = makeRecordUri(name, 'app.bsky.feed.post', rkey)
  const {data: post} = usePostQuery(uri)

  let quoteCount
  if (post) {
    quoteCount = post.quoteCount
  }

  return (
    <Layout.Screen>
      <Layout.Header.Outer>
        <Layout.Header.BackButton />
        <Layout.Header.Content>
          {post && (
            <>
              <Layout.Header.TitleText>
                <Trans>Quotes</Trans>
              </Layout.Header.TitleText>
              <Layout.Header.SubtitleText>
                <Plural
                  value={quoteCount ?? 0}
                  one="# quote"
                  other="# quotes"
                />
              </Layout.Header.SubtitleText>
            </>
          )}
        </Layout.Header.Content>
        <Layout.Header.Slot />
      </Layout.Header.Outer>
      <PostQuotesComponent uri={uri} />
    </Layout.Screen>
  )
}
